// extracted by mini-css-extract-plugin
export default {"inner":"BN1vc","header":"M9z98","preview":"oNvAB","name":"_kEfc","courses":"eryx6","course":"LdOhS","coursePreview":"QMw20","courseTitle":"iXUOk"};